let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("54mYC")).then(() => parcelRequire('9n624'));